export const AGENCY_COVERAGE_BULK_UPLOAD_SAVE_BEGIN = 'syftacp/AGENCY_COVERAGE_BULK_UPLOAD_SAVE_BEGIN'
export const AGENCY_COVERAGE_BULK_UPLOAD_SAVE_FAILED = 'syftacp/AGENCY_COVERAGE_BULK_UPLOAD_SAVE_FAILED'
export const AGENCY_COVERAGE_BULK_UPLOAD_SAVE_SUCCEEDED = 'syftacp/AGENCY_COVERAGE_BULK_UPLOAD_SAVE_SUCCEEDED'
export const AGENCY_COVERAGE_BULK_UPLOAD_CLEAR = 'syftacp/AGENCY_COVERAGE_BULK_UPLOAD_CLEAR'
